<div class="pfxr-results" id="contentToConvert">

  <!-- ══ HEADER ══ -->
  <div class="pfxr-header">
    <div class="pfxr-header-top">
      <div class="pfxr-title-row">
        <div class="pfxr-bar"></div>
        <div>
          <h1 class="pfxr-title">Results</h1>
          <p class="pfxr-sub">The results calculated according to the values entered.</p>
        </div>
      </div>
      <div class="pfxr-btns noprint">
        <a [routerLink]="['/Predictive-Foreign-calculator/question']" class="pfxr-btn-sm">
          <img src="/assets/Frame 1000003040.svg" alt="Back" width="20" height="20">
          Back
        </a>
        <button class="pfxr-btn-sm" (click)="emailpopup()">
          <img src="/assets/Icon.svg" width="14" height="14" alt="">
          Share
        </button>
        <button class="pfxr-btn-green" (click)="startagain()">Recalculate</button>
      </div>
    </div>
  </div>

  <!-- ══ KPI CARDS ══ -->
  <div class="pfxr-kpi-row">

    <!-- Exit value (featured) -->
    <div class="pfxr-kpi pfxr-kpi--feat">
      <div class="pfxr-kpi__icon-wrap">
        <div class="pfxr-icon-blob1"></div>
        <div class="pfxr-icon-blob2"></div>
        <img src="/assets/e8b22e177f552a6f434e1c1fec7ee7376aa4fca6.png" alt="Exit Value">
      </div>
      <div class="pfxr-kpi__inner">
        <div class="pfxr-kpi-lbl">Exit ({{calcData?.homecurrencyText}})</div>
        <div class="pfxr-kpi-val">{{formatHomeCurrency(exitValueHome)}}</div>
        <div class="pfxr-kpi-note">Projected exit value</div>
      </div>
    </div>

    <!-- Initial value -->
    <div class="pfxr-kpi">
      <div class="pfxr-kpi__icon-wrap">
        <div class="pfxr-icon-blob1"></div>
        <div class="pfxr-icon-blob2"></div>
        <img src="/assets/7aa8dbcb61a7c07c2f2a7ed6c6980b0d7de55599 (1).png" alt="Initial Value">
      </div>
      <div class="pfxr-kpi__inner">
        <div class="pfxr-kpi-lbl">Initial ({{calcData?.homecurrencyText}})</div>
        <div class="pfxr-kpi-val">{{formatHomeCurrency(initialValueHome)}}</div>
        <div class="pfxr-kpi-note">Current value in home currency</div>
      </div>
    </div>

    <!-- FX-Only Growth % -->
    <div class="pfxr-kpi">
      <div class="pfxr-kpi__icon-wrap">
        <div class="pfxr-icon-blob1"></div>
        <div class="pfxr-icon-blob2"></div>
        <img src="/assets/7c9f4b3024f2562f5ca2ecd7ac6e5b00e60e5781.png" alt="FX Growth">
      </div>
      <div class="pfxr-kpi__inner">
        <div class="pfxr-kpi-lbl">FX-Only Growth</div>
        <div class="pfxr-kpi-val">{{fxOnlyGrowthPct | number:'1.1-1'}}%</div>
        <div class="pfxr-kpi-note">Over {{calcData?.investedTenure}} Years</div>
      </div>
    </div>

  </div>

  <!-- ══ BODY ══ -->
  <div class="pfxr-body">

    <!-- Assumptions -->
    <div class="pfxr-card">
      <div class="pfxr-card-title">Your Assumptions</div>
      <div class="pfxr-card-sub">All assumptions used in this calculation</div>
      <div class="pfxr-arow">
        <span class="pfxr-arow-lbl">Investment</span>
        <span class="pfxr-arow-val">£{{calcData?.InvestmentGBP | number:'1.0-0'}}</span>
      </div>
      <div class="pfxr-arow">
        <span class="pfxr-arow-lbl">FX Rate</span>
        <span class="pfxr-arow-val">{{calcData?.homecurrencyText}} @ {{calcData?.homecurrency | number:'1.2-2'}}</span>
      </div>
      <div class="pfxr-arow">
        <span class="pfxr-arow-lbl">Growth</span>
        <span class="pfxr-arow-val">{{calcData?.fxgrowth}}% p.a.</span>
      </div>
      <div class="pfxr-arow">
        <span class="pfxr-arow-lbl">Period</span>
        <span class="pfxr-arow-val">{{calcData?.investedTenure}} yrs</span>
      </div>
    </div>

    <!-- FX Value Over Time — chart -->
    <div class="pfxr-card">
      <div class="pfxr-card-title">FX Value Over Time</div>
      <div class="pfxr-card-sub">How your investment value grows in {{calcData?.homecurrencyText}} as FX appreciates</div>
      <div class="pfxr-chart-wrap">
        <canvas id="pfxCanvas"></canvas>
      </div>
    </div>

    <!-- Year-by-Year table -->
    <div class="pfxr-card">
      <div class="pfxr-card-title">Year-by-Year Values</div>
      <div class="pfxr-table-wrap">
        <table class="pfxr-tbl">
          <thead>
            <tr>
              <th>Year</th>
              <th>FX Rate</th>
              <th>{{calcData?.homecurrencyText}} Value</th>
              <th>Growth %</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of yearlyRows">
              <td style="color:#fff;font-weight:600">{{row.year}}</td>
              <td>{{row.rate | number:'1.2-2'}}</td>
              <td >{{formatHomeCurrency(row.value)}}</td>
              <td class="pfxr-td-highlight">+{{row.growthPct | number:'1.1-1'}}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>

  <!-- ══ STICKY FOOTER ══ -->
  <div class="rp-footer noprint">
    <a [routerLink]="['/Predictive-Foreign-calculator/question']" class="rp-footer-btn rp-footer-back">
      <img src="/assets/Icon (1).svg" width="8" height="14" alt="">
      Back
    </a>
    <button class="rp-footer-btn rp-footer-share" (click)="emailpopup()">
      <img src="/assets/Icon.svg" width="15" height="15" alt="">
      Share
    </button>
    <button class="rp-footer-btn rp-footer-recalc" (click)="startagain()">Recalculate</button>
  </div>

</div>

<!-- Share Modal -->
<div class="modal fade noprint" id="myModal">
  <div class="modal-dialog">
    <div class="modal-content" style="top:100px;">
      <div class="modal-header" style="border-bottom:0;padding-bottom:0">
        <h5 class="modal-title" style="color:#1d1751;padding-left:12px;">Share Report</h5>
      </div>
      <div class="modal-body" style="padding-top:20px;padding-bottom:5px;">
        <div class="form-group col-md-12">
          <label style="color:#444854;font-size:14px;">Enter email ids of recipients</label>
          <input type="email" class="form-control" id="email" placeholder="example: joe@gmail.com,mark@gmail.com" name="email" [(ngModel)]="Email" autocomplete="off" style="height:45px !important;">
        </div>
      </div>
      <div class="modal-footer" style="border-top:0;padding-top:0;padding-bottom:8px;">
        <div style="width:100%;display:flex;justify-content:center;">
          <button *ngIf="loadingSharebtn" type="submit" class="btn pfxr-modal-btn"><i class="fa fa-spin fa-spinner"></i> Please Wait...</button>
          <button *ngIf="!loadingSharebtn" type="submit" class="btn pfxr-modal-btn" (click)="shareReport()">Send</button>
          <button type="button" class="btn pfxr-modal-cancel-btn" id="cancelbtn" (click)="cancel()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
